import React, { FC } from 'react';
import Money from '../../../../../Money';
import cn from 'classnames';
import { Money as MoneyType } from '../../../../../types';
import { useTheme } from '../../../../../theme';

interface Props {
	name: string;
	price: MoneyType;
	isMinus?: boolean;
	className?: string;
}

export const PriceItem: FC<Props> = ({ name, price, isMinus, className }) => {
	const { PriceItem: css } = useTheme('PriceDetails');

	const priceWithoutMinus = Math.abs(price.amount);
	const showSing = isMinus && priceWithoutMinus > 0;

	return (
		<div className={cn(css.root, className)}>
			<div className={css.title}>{name}</div>
			<div>
				{!!showSing && <span>-</span>}
				<Money money={{ ...price, amount: priceWithoutMinus }} />
			</div>
		</div>
	);
};

export default PriceItem;
